module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_028"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_028"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("The tubby bellies of Grumman FF-1 fighters made them instantly recognizable in the air. Here, a flight of three FF-1s, called “Fifis” by navy aviators, cruise in cloudy skies. The blue and white markings on the cowlings indicate that the aircraft are from different flight sections. "), _c('em', [_vm._v("U.S. Navy via Stan Piet")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d740f91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_028.vue
// module id = 135
// module chunks = 0